export default __webpack_public_path__ + "static/media/amazon-marked.ab4f1a3b.png";